<div class="lay-wrapper">
    <div class="m-content m-content--contact m-content--large">
        <div class="grid-row">
            <div class="info">{{ 'contact.regional.description' | translate }}</div>
        </div>
        <div class="contact-table-wrapper">
            <table class="contact-table">
                <thead>
                    <tr>
                        <th>{{ 'contact.regional.country' | translate }}</th>
                        <th>{{ 'contact.regional.company' | translate }}</th>
                        <th>{{ 'contact.regional.orgunit' | translate }}</th>
                        <th>{{ 'contact.regional.person' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    @for (element of rows(); track element.country + '-' + element.company + '-' + element.contact) {
                        <tr>
                            <td>
                                <span class="short-text" [title]="element.country">{{ element.country }}</span>
                            </td>
                            <td>
                                <span class="short-text" [title]="element.company">{{ element.company }}</span>
                            </td>
                            <td>
                                <span class="short-text" [title]="element.orgUnit">{{ element.orgUnit }}</span>
                            </td>
                            <td>
                                @if (element.scdLink) {
                                    <span class="short-text contacts-link" [title]="element.contact">
                                        <a target="_blank" rel="noopener noreferrer" [href]="element.scdLink">{{
                                            element.contact
                                        }}</a>
                                        <span class="external-link-icon" aria-hidden="true">↗</span>
                                    </span>
                                } @else {
                                    <span class="short-text" [title]="element.contact">{{ element.contact }}</span>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
